import { produce } from 'immer';
import { EFavoritesActionType, IFavoritesAction } from '../favorites/actions';
import { initialRootState } from '../initialRootState';
import { IVisitsAction } from '../visits/actions';
import { EMatchesActionType, TMatchesActions } from './actions';
import { IMatchesState } from './types';

export const matchesReducer = (
  currentState: IMatchesState = initialRootState.matches,
  action: TMatchesActions | IVisitsAction | IFavoritesAction
): IMatchesState =>
  produce(currentState, (draft: IMatchesState) => {
    switch (action.type) {
      case EMatchesActionType.GET_AFFINY_MATCH_LIST_SUCCESS:
        draft.affiny.list = action.payload.result.data;
        draft.affiny.originalList = action.payload.result.data;
        break;
      case EMatchesActionType.GET_AFFINY_ADDITIONAL_MATCH_LIST_SUCCESS:
        draft.affiny.additionalList = action.payload.result.data;
        break;
      case EMatchesActionType.REPLACE_AFFINY_MATCH_LIST_BY_ADDITIONAL_MATCHLIST:
        draft.affiny.list = draft.affiny.additionalList;
        draft.affiny.originalList = draft.affiny.additionalList;
        draft.affiny.additionalList = [];
        break;
      case EMatchesActionType.GET_SORT_MATCH_LIST_SUCCESS:
        const {
          meta: {
            pagination: { current_page: currentPage, total },
          },
          data,
        } = action.payload.result;

        draft.sort.meta = { currentPage, total };
        draft.sort.list = draft.sort.list.concat(data);
        break;
      case EMatchesActionType.SET_SORT_TYPE_SUCCESS:
        draft.sort.sortType = action.payload.sortType;
        break;
      case EMatchesActionType.RESET_MATCH_LIST:
        draft.sort.meta = initialRootState.matches.sort.meta;
        draft.sort.list = initialRootState.matches.sort.list;
        break;
      case EFavoritesActionType.POST_FAVORITE:
        Object.keys(draft).forEach(key => {
          draft[key].list = draft[key].list.filter(
            (id: string) => id !== action.payload.accountId
          );
        });
        break;
      case EMatchesActionType.REMOVE_USER_AFFINY_MATCHES:
        draft.affiny.list = draft.affiny.list.filter(
          id => id !== action.payload.accountId
        );
        break;
    }
  });
